import React, { useState } from "react";
import { ShareAltOutlined, CheckOutlined, GlobalOutlined } from "@ant-design/icons";
import { Button, Modal, message, Input, Divider, Tooltip } from "antd";
import "./ShareButton.css";

function ShareButton({ shareUrl = window.location.href, title = "Check this out!" }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleShareClick = () => {
    setIsModalVisible(true);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    message.success("Link copied to clipboard!");
    setTimeout(() => setCopied(false), 2000);
  };

  const handleNativeShare = async () => {
    try {
      await navigator.share({ title, url: shareUrl });
    } catch (err) {
      console.log("Native sharing cancelled:", err);
    }
  };

  const shareOptions = [
    {
      name: "Facebook",
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      icon: "🌐",
    },
    {
      name: "LinkedIn",
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
      icon: "💼",
    },
    {
      name: "Email",
      url: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`${title}\n\n${shareUrl}`)}`,
      icon: "✉️",
    },
  ];

  return (
    <>
      <Tooltip title="Share this page">
        <Button
          type="default"
          icon={<ShareAltOutlined />}
          onClick={handleShareClick}
          className="enhanced-share-button"
        >
          Share
        </Button>
      </Tooltip>

      <Modal
        title="Share This Page"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        centered
        className="share-modal"
      >
        <div className="share-url-container">
          <Input value={shareUrl} readOnly className="share-url-input" />
          <Button type="primary" onClick={handleCopyLink} icon={copied ? <CheckOutlined /> : null}>
            {copied ? "Copied!" : "Copy Link"}
          </Button>
        </div>

        <Divider plain>Or share on</Divider>

        <div className="social-share-buttons">
          {navigator.share && (
            <Button
              onClick={handleNativeShare}
              icon={<GlobalOutlined />}
              className="native-share-button"
            >
              Share via Device
            </Button>
          )}

          {shareOptions.map((option) => (
            <a
              key={option.name}
              href={option.url}
              target="_blank"
              rel="noopener noreferrer"
              className="social-share-link"
            >
              <Button type="default" className="social-button">
                <span className="emoji-icon">{option.icon}</span> {option.name}
              </Button>
            </a>
          ))}
        </div>
      </Modal>
    </>
  );
}

export default ShareButton;
